import { useState } from "react";
import { MdCheckCircle } from "react-icons/md";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import { getTrackingQAnsweredEachForm } from "../store/qf";
import { COLORS } from "../theme";

const FormCompleteIcon = ({ formid = null }) => {
  const trackingQAnsweredEachForm = useSelector(
    getTrackingQAnsweredEachForm({ formid })
  );
  const [isHover, setIsHover] = useState(false);
  const colorIcon = ({
    totalImp,
    totalImpAnswered,
    totalAnswerableQuestions,
    totalQAnswered,
  }) => {
    if (
      totalAnswerableQuestions === totalQAnswered &&
      !isNaN(totalAnswerableQuestions) &&
      !isNaN(totalQAnswered) &&
      totalAnswerableQuestions !== 0
    )
      return COLORS.green_dot;
    if (
      totalImpAnswered === totalImp &&
      !isNaN(totalImpAnswered) &&
      !isNaN(totalImp) &&
      totalImp !== 0
    )
      return COLORS.secondary_orange;
    return null;
  };

  let color = null;
  try {
    color = colorIcon({
      totalAnswerableQuestions:
        trackingQAnsweredEachForm.totalAnswerableQuestions,
      totalImp: trackingQAnsweredEachForm.totalImp,
      totalImpAnswered: trackingQAnsweredEachForm.totalImpAnswered,
      totalQAnswered: trackingQAnsweredEachForm.totalQAnswered,
    });
  } catch (e) {}

  if (color)
    return (
      <>
        <MdCheckCircle
          onMouseOver={() => {
            setIsHover(true);
          }}
          onMouseOut={() => {
            setIsHover(false);
          }}
          color={color}
          data-for={`${formid}completeIcon`}
          data-tip="1"
        ></MdCheckCircle>
        <ReactTooltip
          id={`${formid}completeIcon`}
          effect="solid"
          clickable={true}
          place="top"
        >
          <ToolTipForDoneIcon
            trackingQAnsweredEachForm={trackingQAnsweredEachForm}
          ></ToolTipForDoneIcon>
        </ReactTooltip>
      </>
    );

  return null;
};

const ToolTipForDoneIcon = ({ trackingQAnsweredEachForm }) => {
  return (
    <div>
      <ul>
        <li>{`Total Questions: ${trackingQAnsweredEachForm.totalAnswerableQuestions}`}</li>
        <li>{`Total Question answered: ${trackingQAnsweredEachForm.totalQAnswered}`}</li>
        <li>{`Total Essential Questions: ${trackingQAnsweredEachForm.totalImp}`}</li>
        <li>{`Total Essential Questions answered: ${trackingQAnsweredEachForm.totalImpAnswered}`}</li>
      </ul>
    </div>
  );
};

export default FormCompleteIcon;
